export enum FulfillmentDateType {
  FulfillmentDateType = 'FULFILLMENT_UPDATE_EXPECTED_DATE',
  OfficialFulfillmentDate = 'OFFICIAL_FULFILLMENT_DATE',
}
